import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";

// redux
import { shallowEqual, useDispatch, useSelector } from "react-redux";

// router
import { useNavigate } from "react-router-dom";

// sayfalar, modallar vb.

// görseller
import SuccessImg from "../../assets/images/pay-success.png";

const Success = () => {
  const navigate = useNavigate();

  const [decodedString, setDecodedString] = useState("");

  useEffect(() => {
    try {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const encodedData = urlParams.get("m");

      if (!encodedData) {
        throw new Error("URL'de 'm' parametresi bulunamadı.");
      }

      const base64Decoded = decodeURIComponent(encodedData);
      const decoded = decodeURIComponent(
        Array.from(atob(base64Decoded))
          .map((char) => `%${char.charCodeAt(0).toString(16).padStart(2, "0")}`)
          .join("")
      );

      setDecodedString(decoded);
    } catch (error) {
      console.error("URL verisi çözülürken hata oluştu:", error);
      navigate("/", { replace: true });
    }
  }, []);

  document.title = "Ödeme Başarılı | Global Yol Yardım";
  return (
    <React.Fragment>
      <div className="auth-page-content" style={{ background: "white" }}>
        <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100">
          <div className="auth-page-content overflow-hidden p-0">
            <Container>
              <Row className="justify-content-center text-center">
                <Col xl={4} lg={5}>
                  <div>
                    <img
                      src={SuccessImg}
                      alt="page not found img"
                      className="img-fluid"
                    />
                    <h4 className="mt-4 text-primary">{decodedString}</h4>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Success;
